import { FC, JSX, useEffect, useState } from "react";
import "./UsersList.scss";
import MasterPage from "../../../../pages/MasterPage/MasterPage";
import PageBase from "../../../../components/PageBase/PageBase";
import SkeletonTable from "../../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../../providers/PaginateProvider";
import ModalUsersInsert from "../../../../components/Access/Users/ModalUsersInsert/ModalUsersInsert";
import { useSidebarFilter } from "../../../../providers/SidebarFilterProvider";
import SidebarUsersFilter from "../../../../components/Access/Users/SidebarUsersFilter/SidebarUsersFilter";
import { useUsers } from "../../../../providers/Access/Users/UsersProvider";
import { UserModel } from "../../../../models/Access/Users/UserModel";
import { useAccessProfile } from "../../../../providers/Access/AccessProfile/AccessProfileProvider";
import moment from "moment";

interface UsersListProps { }

const UsersList: FC<UsersListProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);

  const {
    pages,
    params,
    setParams,
    isLoading,
    error,
    users,
    setUser,
    handleList,
    handleDelete,
    setIsLoading,
    handleReactivate,
  } = useUsers();
  const { setParams: setParamsAccessProfile } = useAccessProfile();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  const handleEdit = (item: UserModel) => {
    setUser(item);
    setShowModalInsert(true);
  };

  const handleReactivateItem = async (itemId: number) => {
    if (itemId <= 0) return;

    const ret = await handleReactivate(itemId);

    if (ret) {
      toast.success("Usuário reativado com sucesso!");
      handleList();
    }
  };

  const handleDeleteUsersList = (item: UserModel) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir o usuário ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Usuário inativado com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar o usuário.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {users?.length > 0 ? (
          <>
            {users.map((x: UserModel, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td>{x?.partner_code}</td>
                <td>{x?.name}</td>
                <td>{x?.access_profile?.name}</td>
                <td>{x?.user_type?.name}</td>
                <td>{x?.email}</td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {!x?.deleted_at && (
                      <>
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleEdit(x)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                          Editar
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeleteUsersList(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>
                      </>
                    )}
                    {x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleReactivateItem(x?.id ?? 0)}
                      >
                        <FontAwesomeIcon
                          icon={faCircleCheck}
                          className="me-2"
                        />
                        Reativar
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={9} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Código Parceiro
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nível de Acesso
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Tipo de Usuário
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Email
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {users?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    !!showModalInsert &&
      setParamsAccessProfile({
        withPaginate: false,
        filter: { only_active: true },
      });
  }, [showModalInsert]);

  useEffect(() => {
    setParams({ ...params, page: 1, filter: {} });
  }, []);

  return (
    <MasterPage title="Usuários" icon="fas fa-file" footerFixed>
      <div className="UsersList" data-testid="UsersList">
        <PageBase
          title="Usuários"
          subtitle="Gerenciamento dos usuários do sistema."
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          hasFilter
          useButtonGroup
        />

        <ModalUsersInsert
          show={showModalInsert}
          onClose={() => setShowModalInsert(false)}
        />
      </div>

      <SidebarUsersFilter />
    </MasterPage>
  );
};

export default UsersList;
